import { Person } from '@mui/icons-material';
import { Box, Chip, Typography } from '@mui/material';
import { CollapsibleSection } from './CollapsibleSection';
import { ExecutionRunCard } from './ExecutionRunCard';
import type { ExecutionRunGroup } from './executionRunGroup.types';

interface UserMessageGroupProps {
  group: ExecutionRunGroup;
  defaultExpanded?: boolean;
}

export function UserMessageGroup({ group, defaultExpanded = false }: UserMessageGroupProps) {
  const truncatedMessage =
    group.triggerMessage.content.length > 60
      ? group.triggerMessage.content.slice(0, 60) + '...'
      : group.triggerMessage.content;

  const headerTitle = (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flex: 1 }}>
      <Person fontSize="small" sx={{ color: 'info.main' }} />
      <Typography variant="body2" sx={{ fontWeight: 'medium', flex: 1 }}>
        "{truncatedMessage}"
      </Typography>
      <Chip size="small" label={`${group.runs.length} runs`} variant="outlined" />
      <Typography variant="caption" sx={{ color: 'text.secondary' }}>
        {group.totalInputTokens} in / {group.totalOutputTokens} out
      </Typography>
    </Box>
  );

  return (
    <Box sx={{ mb: 2, p: 1.5, bgcolor: 'white', borderRadius: 1, border: '1px solid', borderColor: 'divider' }}>
      <CollapsibleSection title={headerTitle} defaultExpanded={defaultExpanded}>
        <Box sx={{ mt: 1 }}>
          {group.runs.map((run) => (
            <ExecutionRunCard key={run.id} run={run} />
          ))}
        </Box>
      </CollapsibleSection>
    </Box>
  );
}
